export default __webpack_public_path__ + "static/media/text.df6ed53e.jpg";